module.exports = __webpack_public_path__ + "static/media/JV.7e770898.webp";